export const errorMessageTheme = {
  text: 'palette.error.60',
};
